import React from "react";

import bgHeader from "./../graphics/elements/leagueBgHeader.svg";
import styles from "./HeaderTopic.module.css";

function HeaderTopic(props) {
  const { topic } = props;

  return (
    <div>
      <div className={styles.header}>
        <img src={bgHeader} alt="כותרת" />
        <h1>{topic}</h1>
      </div>
    </div>
  );
}

export default HeaderTopic;
